import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentViewModel } from '../../viewModels/documents/documentViewModel';
import { UploadViewModel } from '../../viewModels/documents/uploadViewModel';
import { ObjectTypes } from '../../enums/objectTypes';
import { ChecklistDocumentViewModel } from '../../models/checklists/checklistAttachmentsViewModel';
import { DocumentCategoryViewModel } from '../../viewModels/documents/documentCategoryViewModel';
import { DocumentService } from '../document.service';
import { DocumentCategoryService } from '../documentCategory.service';
import { DocumentAbstraction } from './document.abstraction';

/**
 * Implementation for normal authenticated users
 * Delegates to the existing DocumentService
 */
@Injectable({
  providedIn: 'root',
})
export class NormalUserDocumentService extends DocumentAbstraction {
  constructor(
    private documentService: DocumentService,
    private documentCategoryService: DocumentCategoryService
  ) {
    super();
  }

  addDocument(uploadViewModel: UploadViewModel, externalShareId?: string): Observable<DocumentViewModel> {
    return this.documentService.addDocument(uploadViewModel);
  }

  updateDocument(uploadViewModel: UploadViewModel): Observable<DocumentViewModel> {
    return this.documentService.updateDocument(uploadViewModel);
  }

  deleteDocument(documentId: number, globalObjectId: number, globalObjectType: number): Observable<void> {
    return this.documentService.deleteDocument(documentId, globalObjectId, globalObjectType);
  }

  getByObjectId(objectId: number, objectType: ObjectTypes, externalShareId?: string): Observable<DocumentViewModel[]> {
    return this.documentService.getByObjectId(objectId, objectType);
  }

  uploadFile(file: File, isAttachment: boolean = false, isAccountLogo: boolean = false): Observable<string> {
    return this.documentService.uploadFile(file, isAttachment, isAccountLogo);
  }

  uploadPart(part: number, originalFileName: string, file: File, externalShareId?: string): Observable<void> {
    return this.documentService.uploadPart(part, originalFileName, file);
  }

  completeUpload(originalFileName: string, newFileName: string, isAttachment: boolean, isAccountLogo: boolean, externalShareId?: string): Observable<string> {
    return this.documentService.completeUpload(originalFileName, newFileName, isAttachment, isAccountLogo);
  }

  deleteUnassignedFile(fileName: string): Observable<void> {
    return this.documentService.deleteUnassignedFile(fileName);
  }

  getObjectChecklistDocuments(objectId: number, objectType: ObjectTypes): Observable<ChecklistDocumentViewModel[]> {
    return this.documentService.getObjectChecklistDocuments(objectId, objectType);
  }

  downloadDocument(id: number): void {
    this.documentService.downloadDocument(id);
  }

  splitUploadFile(file: File, compress: boolean = false, isAttachment: boolean = true, isAccountLogo: boolean = false, externalShareId?: string): Observable<string> {
    return this.documentService.splitUploadFile(file, compress, isAttachment, isAccountLogo);
  }

  getDocumentCategoriesWithDocuments(externalShareId?: string): Observable<DocumentCategoryViewModel[]> {
    return this.documentCategoryService.getDocumentCategoriesWithDocuments();
  }
}
